import React from 'react';

// E-mail。信封。
const IconMail = ({ onClick }) => {
	return (
		<div className='IconMail' onClick={onClick}>
			<svg
				width='20'
				height='20'
				viewBox='0 0 24 24'
				fill='none'
				stroke='#333333'
				strokeWidth='1.6'
				strokeLinecap='round'
				strokeLinejoin='round'
				xmlns='http://www.w3.org/2000/svg'
			>
				<rect x='2.8' y='5' width='18.4' height='14' rx='2' />
				<path d='M3.4 6.2 12 12.6l8.6-6.4' />
			</svg>
		</div>
	);
};

export default IconMail;
